<template>
    <div>
        
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
             <el-alert  type="success" effect="dark" :closable="false">
                <div style="line-height: 2;font-size: 16px" solt="description">
                   跨境店货代出库
                </div>
            </el-alert>
            <el-form ref="queryParams" style="margin-top: 20px" inline label-position="right" label-width="120px" @submit.native.prevent="()=>{}">
                <el-form-item label="货运订单号">
                    <el-input ref="waybillOrder" size="small" v-model="waybillOrder" @keyup.enter.native="toGo" placeholder="货运订单号" style="width: 240px" />
                    <Label>累计出库：{{total}}</Label>

                     <el-checkbox style="margin-left:10px;" v-model="showOk" @change="setMouse">固定鼠标</el-checkbox>
                </el-form-item>
            </el-form>
            <Timeline>
                <TimelineItem v-for="(order,ind) in orders" :key="ind">
                    <p class="time">{{order.waybillOrder}}</p>
                    <p class="content">
                        【<a target="_blank" :href="'/#/waybill/show/'+order.waybillOrder">{{order.waybillOrder}}</a>】{{order.state==1?'出库成功':order.msg}}
                    </p>
                </TimelineItem>
            </Timeline>
        </Content>
    </div>
</template>
<script>
import iNotify from '@/assets/iNotify';
import api from '@/api/api'
export default {
    name: 'Express',
    data() {
        return {
            total:0,
            waybillOrder: "",
            orders: [],
            showOk:true,
            root: api.root,
            focusTimer:null
        };
    },
    beforeRouteLeave(to, form, next) {
        if (this.fouceTimer) {
            window.clearInterval(this.fouceTimer)
        }
        next()

    },
    mounted: function() {
        this.$refs['waybillOrder'].focus();
        this.setMouse(true);
    },
    methods: {
        setMouse(val) {
            var me = this;
            if (val) {
                me.fouceTimer = setInterval(function() {
                    me.$refs['waybillOrder'].focus();
                }, 500);
            } else {
                if (this.fouceTimer) {
                    window.clearInterval(this.fouceTimer)
                }
            }
        },
        toGo: function() {
            var me = this;
            if (!me.waybillOrder) return;
            var obj = { waybillOrder: me.waybillOrder, state: 0 };
            me.$http.post("/ware/waybill/outgoing.action", { waybillOrder: me.waybillOrder }).then(response => {
                var body = response;

                if (body.status == 0) {
                    obj['state'] = 1;
                    me.total++;
                    iNotify.player("waybillok")
                } else if (body.status == 1) {//重复扫码
                    obj['state'] = -1;
                    
                    iNotify.player("waybillok1")
                }else if (body.status == -4) {//有包裹未签收
                    obj['state'] = -1;
                    iNotify.player("waybillerror2")
                } else if (body.status == -3) {//订单已取消了，无需要出库
                    obj['state'] = -1;
                    iNotify.player("waybillerror3")
                }  else {
                    obj['msg'] = body.info;
                    obj['state'] = -1;
                    iNotify.player("waybillerror")
                }
                obj.msg=body.info;
                me.orders.unshift(obj);
            }, response => {
                obj['msg'] = "请求异常";
                obj['state'] == -1;
                me.orders.unshift(obj);
                iNotify.player("waybillerror")
            });



            me.waybillOrder = "";
            me.$refs['waybillOrder'].focus();

        }
    }
}
</script>
<style scoped>
</style>